import { render, staticRenderFns } from "./smart-page-layout.vue?vue&type=template&id=7e133c92&"
import script from "./smart-page-layout.vue?vue&type=script&lang=js&"
export * from "./smart-page-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports